import React, { ReactElement } from 'react';

import Button from '../../../Components/Button/Button';
import styles from '../styles.module.scss';

const ContactCustomerServices = (): ReactElement => {
  return (
    <div className={styles.formContainer}>
      <span className={`${styles.formTitle} p-b-26`}>
        <span className={`${styles.formTitleForgot} fs-unmask`}>Update Email Address</span>
      </span>
      <div className={`text-center ${styles.formTitleLink} p-t-115 fs-unmask`} style={{ marginTop: '32px' }}>
        <span className={`${styles.txt1} txt1`}>
          Please reach out to customer support to verify your identity to make this change.
        </span>
      </div>
      <div className={styles.buttonContainer}>
        <div className={styles.buttonWrapper}>
          <Button
            type="button"
            className={styles.formBtn}
            onClick={() => {
              window.open('https://dentistryone.zendesk.com/hc/en-us', '_blank');
            }}
          >
            Contact Customer Support
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactCustomerServices;
